import { render } from "./IconMore.vue?vue&type=template&id=323f7a84"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "323f7a84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('323f7a84', __exports__)) {
    api.reload('323f7a84', __exports__)
  }
  
  module.hot.accept("./IconMore.vue?vue&type=template&id=323f7a84", () => {
    api.rerender('323f7a84', render)
  })

}


export default __exports__